module.exports = __webpack_public_path__ + "static/img/ccod2.ffb2aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod2.png
// module id = Mj9S
// module chunks = 0